<template>
  <div class="container">
    <div :class="{ 'hover-search-fix': topSearchShow }"></div>
    <Spin fix v-if="modelFormShow"></Spin>
    <div class="SaaSbanner">
      <img :src="require('@/assets/images/B2Bbanner.png')" />
    </div>
    <div class="SaaScontent">
      <div class="SaaStitle flex flex-v flex-align-center">
        <p class="p1">B2B电商交易系统核心能力</p>
      </div>
      <div style="padding: 20px">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6"
                  v-for="(item, index) in SaaSclist"
                  :key="index">
            <div class="SaaScitem flex flex-v flex-align-center">
              <img :src="item.img" width="65" height="65" class="xt" />
              <p class="p1">{{ item.title }}</p>
              <p class="p2">{{ item.content }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="SaaSCard">
      <div class="SaaSXITONG">
        <img class="wnsxbg" :src="require('@/assets/images/wnsxbg.png')" />
        <div class="SaaStitle flex flex-v flex-align-center">
          <p class="p1" style="margin-top:30px;">B2B电商交易系统能为你实现</p>
        </div>
        <div class="SaaSXITONGBOX flex flex-l flex-pack-justify">
          <div class="sl flex flex-v">
            <div v-for="(item, index) in Cardlist" @click="setCardinfo(item)"
            :key="index" class="slitem flex flex-v" :class="{'slsjx':Cardinfo.id == item.id}">
              <!-- <div class="slitemsjx"></div> -->
              <img :src="require('@/assets/images/sltop.png')" class="sltop" />
              <img v-if="Cardinfo.id == item.id" :src="item.checkimg" :class="'sl0'+(index+1)"/>
              <img v-else :src="item.numimg" :class="'sl0'+(index+1)"/>
              <p class="p1">{{item.title}}</p>
            </div>
          </div>
          <div class="sr flex flex-v">
            <div class="srbox">
              <img :src="Cardinfo.img" width="820" height="380"/>
            </div>
            <div class="srcontent flex flex-v">
              <p class="p1">{{ Cardinfo.title }}</p>
              <p class="p2">{{ Cardinfo.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="SaaStitle flex flex-v flex-align-center">
        <p class="p1">供应链管理系统适用行业</p>
      </div>
      <div class="Cardfooter flex flex-l flex-pack-justify">
        <div class="Cardleft flex flex-v flex-pack-justify">
          <div class="Cardt flex flex-l flex-pack-justify">
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter01.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>化工/工业</p>
              </div>
            </div>
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter02.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>建筑建材</p>
              </div>
            </div>
          </div>
          <div class="Cardbottom flex flex-l flex-pack-justify">
            <div class="Cardbottom-l flex flex-v">
              <div class="Carditem2">
                <img
                  :src="require('@/assets/images/Cardfooter03.png')"
                  width="285"
                  height="480"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>原材料</p>
                </div>
              </div>
            </div>
            <div class="Cardbottom-r flex flex-v flex-pack-justify">
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter04.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>快消品</p>
                </div>
              </div>
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter05.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>医药行业</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Cardright flex flex-v flex-pack-justify">
          <div class="Cardt flex flex-l flex-pack-justify">
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter06.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>农林副业</p>
              </div>
            </div>
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter07.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>环保</p>
              </div>
            </div>
          </div>
          <div class="Cardbottom flex flex-v flex-pack-justify">
            <div class="Cardbottom-l flex flex-v">
              <div class="Carditem3">
                <img
                  :src="require('@/assets/images/Cardfooter08.png')"
                  width="590"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>机械设备</p>
                </div>
              </div>
            </div>
            <div class="Cardbottom-r flex flex-l flex-pack-justify">
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter09.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>钢铁行业</p>
                </div>
              </div>
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter10.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>更多行业</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SaaSfooter flex flex-l">
      <div class="SaaSfl flex flex-v flex-align-center">
        <img
          :src="require('@/assets/images/SaaSflimg.png')"
          class="SaaSflimg"
        />
        <p class="pp">1v1按需求定制个性化方案，全程360°为您服务</p>
        <!-- <div class="SaaSflbox flex flex-l flex-pack-justify">
          <div class="flex-text SaaSflitem">
            <img
              :src="require('@/assets/images/dhico.png')"
              width="26"
              height="23"
              class="dhico"
            />
            <p class="p1">0512-56308111</p>
          </div>
          <div class="sline">|</div>
          <div class="flex-text SaaSflitem">
            <img
              :src="require('@/assets/images/dhico2.png')"
              width="20"
              height="20"
              class="dhico"
            />
            <p class="p2">赵经理181-5113-1688</p>
          </div>
        </div> -->
      </div>
      <div class="SaaSfr">
        <img
          :src="require('@/assets/images/SaaSfrimg.png')"
          class="SaaSfrimg"
        />
      </div>
    </div>
    <!-- 底部栏 -->
    <BaseFooter></BaseFooter>
    <!--  -->
  </div>
</template>

<script>
export default {
  name: "Index",
  mounted() {
    var navid = this.$route.params.navid;
    if (navid) this.navid = navid;
    // this.getIndexData();
    let that = this;
    window.onscroll = function () {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(top)
      if (top > 37) {
        that.topSearchShow = true;
      } else {
        that.topSearchShow = false;
      }
    };

    window.scrollTo(0, 0);
  },
  data() {
    return {
      bannerlist: [
        { img: require("@/assets/images/scmbanner.png") },
        { img: require("@/assets/images/scmbanner2.png") },
        { img: require("@/assets/images/scmbanner3.png") },
        { img: require("@/assets/images/scmbanner4.png") },
      ],
      Cardinfo: {
        id:0,
        numimg: require("@/assets/images/sl01b.png"),
        checkimg: require("@/assets/images/sl01.png"),
        img: require("@/assets/images/cardbg2.png"),
        title: "B2B系统：简化供采交易路径，全链路数字化",
        content:
          "B2B系统，商品信息全过程数字化管理、在线询价管理、订单管理、支付管理、电子合同、评估体系等，简化了供采双方的交易路径，实现了交易智能化、数字化。",
      },
      Cardlist: [
        {
          id:0,
          numimg: require("@/assets/images/sl01b.png"),
          checkimg: require("@/assets/images/sl01.png"),
          img: require("@/assets/images/cardbg2.png"),
          title: "B2B系统：简化供采交易路径，全链路数字化",
          content:
            "B2B系统，商品信息全过程数字化管理、在线询价管理、订单管理、支付管理、电子合同、评估体系等，简化了供采双方的交易路径，实现了交易智能化、数字化。",
        },
        {
          id:1,
          numimg: require("@/assets/images/sl02b.png"),
          checkimg: require("@/assets/images/sl02.png"),
          img: require("@/assets/images/cardbg4.png"),
          title: "B2B系统：智能管控，提升交易效率",
          content:
            "通过在线交易平台B2B系统帮助企业管理订单、商品、客户、支付、营销和销售人员，快速带动销售、仓储、采购、财务等内部环节的运行。",
        },
        {
          id:2,
          numimg: require("@/assets/images/sl03b.png"),
          checkimg: require("@/assets/images/sl03.png"),
          img: require("@/assets/images/cardbg5.png"),
          title: "B2B系统：授信支付与供应链金融，安全可靠轻松交易",
          content:
            "b2b电商系统支持大额在线支付，平台提供授信评估，风控预警，对接第三方金融平台，为供采双方搭建可信的供应链金融服务平台。",
        },
      ],
      SaaSclist: [
        {
          img: require("@/assets/images/b2b001.png"),
          title: "商品管理",
          content:
            "自定义规格属性，独立SKU使得库存、订单、结算清晰明了，管理各渠道商品的审核，确保商品管理灵活高效",
        },
        {
          img: require("@/assets/images/b2b002.png"),
          title: "合同管理",
          content:
            "合同管理功能为使用电子签名的电子合同，确保签约主体的真实可靠，大大提高了工作效率",
        },
        {
          img: require("@/assets/images/b2b003.png"),
          title: "订单管理",
          content:
            "企业采购订单自动生成，订单状态实时更新，及时对账，简化企业采购审批流程，可及时进行订单管控",
        },
        {
          img: require("@/assets/images/b2b004.png"),
          title: "仓储管理",
          content:
            "通过入库、出库、变革管理与作业模式提高仓储管理数据准确性，有效控制并跟踪仓库业务的物流",
        },
        {
          img: require("@/assets/images/b2b005.png"),
          title: "供应链金融",
          content:
            "多种供应链金融模式，衔接第三方征信服务，对接、评级、授信、审批、放贷、还款、逾期处理等",
        },
        {
          img: require("@/assets/images/b2b006.png"),
          title: "供应商管理",
          content:
            "涵盖供应商入驻、认证、考察、合作、绩效评估全流程业务，挖掘优秀供应商、淘汰劣质供应商",
        },
        {
          img: require("@/assets/images/b2b007.png"),
          title: "支付管理",
          content:
            "满足企业多样化的支付方式，提供灵活专业的资金结算，支持大额网关支付、退款、安全保障、差错处理等服务",
        },
        {
          img: require("@/assets/images/b2b008.png"),
          title: "大数据服务",
          content:
            "构建大数据采集、预处理和存储，实现产品ABC分析、区域分布图分析，支撑精准营销及数据化运营",
        },
      ],
      navid: 0,
      topSearchShow: false, // 滚动后顶部搜索栏展示
      modelFormShow: false,
    };
  },
  // created(){

  // },
  methods: {
    setCardinfo(item) {
      if (item) {
        this.Cardinfo = item;
      } else {
        this.Cardinfo = {
          id:0,
          numimg: require("@/assets/images/sl01b.png"),
          checkimg: require("@/assets/images/sl01.png"),
          img: require("@/assets/images/cardbg2.png"),
          title: "打通“四流”，提高供应链协同水平",
          content:
            "提升核心企业产业链一体化运作效率；实现商流、物流、信息流、资金流四流合一；借助敏前台、强中台的供应链平台，快速应对复杂的商业场景，优化全流程。",
        };
      }
    }
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
.container {
  box-sizing: border-box;
  background-color: rgba(250, 250, 250, 1);
  transition: 0.35s;
  [data-theme="dark"] & {
      background-color: #1d1d1d;
  }
  [data-theme="light"] & {
      background-color:  rgba(250, 250, 250, 1);
  }
  position: relative;
}
.SaaSbanner {
  width: 100%;
  height: 400px;
  overflow: hidden;
  position: relative;
  // margin-bottom: 82px;
  > img {
    display: block;
    margin: 0 auto;
    width: 1920px;
    height: 400px;
  }
  .SaaSCar {
    width: 1276px;
    height: 118px;
    position: absolute;
    left: 50%;
    bottom: -80px;
    transform: translate(-50%, 0);

    .Caritem {
      width: 304px;
      height: 118px;
      padding: 16px 20px;
      background: #ffffff;
      box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.04);
      .p1 {
        margin-top: 4px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }

      .p2 {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
      > img {
        margin-right: 20px;
      }
      .zy1 {
        width: 90px;
        height: 87px;
      }
      .zy2 {
        width: 104px;
        height: 84px;
      }
      .zy3 {
        width: 107px;
        height: 70px;
      }
      .zy4 {
        width: 90px;
        height: 70px;
      }
    }
  }
}
.SaaScontent {
  max-width: 1200px;
  margin: 0 auto 10px;
  .SaaStitle {
    width: 100%;
    .p1 {
      margin-top: 50px;
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .p2 {
      margin-top: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
    }
  }
  .SaaScitem {
      // cursor: pointer;
      // margin-right: 20px;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      height: 236px;
      background: #ffffff;
      // box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.04);
      padding: 30px 11px 30px 10px;
      box-sizing: border-box;
      .xt {
        width: 65px;
        height: 65px;
      }
      .p1 {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        // margin-top: 10px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }
      .p2 {
        margin-top: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
      .xtmore {
        position: absolute;
        bottom: 20px;
        right: 20px;
        height: 16px;
        .p3 {
          font-size: 12px;
          font-weight: 400;
          color: #ff7f50;
          line-height: 16px;
        }
        .jtimg {
          width: 4px;
          height: 8px;
          margin-left: 5px;
        }
      }
    }
  .SaaSclist {
    margin-top: 80px;
    width: 1220px;
    flex-wrap: wrap;
    
  }
  .fwhy {
    width: 1176px;
    height: 440px;
    margin-left: 12px;
    margin-top: 50px;
  }
}
.SaaSCard {
  width: 100%;
  background-color: #fff;
  .SaaSXITONG {
    width: 100%;
    height: 687px;
    position: relative;
    .wnsxbg {
      width: 1920px;
      max-width: 100%;
      height: 687px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .SaaStitle {
      position: relative;
    }
    .SaaSXITONGBOX {
      
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      margin-top: 30px;
      height: 562px;
      .sl {
        width: 30%;
        .slitem::before{
          position: absolute;
          right: -10px;
          top: 55px;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 10px solid #ff7f50;
        }
        
        .slitem {
          margin-bottom: 20px;
          // height: 120px;
          width: calc(100% - 20px);
          position: relative;
          background: #fff;
          padding-left: 20px;
          padding-bottom: 20px;
          padding-right: 20px;
          color: #333333;
          box-sizing: border-box;
          
          .sl01 {
            width: 68px;
            height: 78px;
          }
          .sl02 {
            width: 89px;
            height: 78px;
          }
          .sl03 {
            width: 87px;
            height: 78px;
          }
          .sltop {
            width: 360px;
            height: 120px;
            position: absolute;
            top: 0;
            left: 0;
          }
          .p1 {
            font-size: 18px;
            font-weight: 400;
            
            line-height: 28px;
          }
        }
        .slsjx{
          color: #ffffff;
          background: #ff7f50;
        }
        .slsjx::before{
          content:'';
          position: absolute;
          right: -14px;
          top: 50%;
          transform: translate(-50%,0);
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 10px solid #ff7f50;
        }
        
      }

      .sr {
        width: 70%;
        .srbox{
          width: 100%;
          height: 380px;
          background: #FFFFFF;
          border-radius: 0px 50px 0px 50px;
          opacity: 1;
          overflow: hidden;

        }
        .srcontent{
          margin-top: 20px;
          background: #FFFFFF;
          border-radius: 20px 20px 20px 20px;
          padding: 25px 30px;
          width: 100%;
          min-height: 162px;
          box-sizing: border-box;
          .p1{
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            line-height: 26px;
          }
          .p2{
            margin-top: 20px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
          }
        }
      }
    }
  }
  .SaaStitle {
    width: 100%;
    .p1 {
      margin-top: 50px;
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .p2 {
      margin-top: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
    }
  }
  .Cardtop {
    width: 1200px;
    height: 720px;
    margin: 30px auto 0;
    position: relative;
    .cardbg1 {
      width: 1200px;
      height: 623px;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    .Cardbox {
      width: 750px;
      height: 392px;
      background: #ffffff;
      box-shadow: 0px -4px 20px 1px rgba(0, 0, 0, 0.03);
      position: relative;
      margin-left: 150px;
      .cardbg2 {
        width: 710px;
        height: 250px;
        margin-top: 20px;
      }
      .Cardboxtext {
        width: 100%;
        height: 122px;
        padding: 20px;
        .p1 {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          line-height: 24px;
          margin-bottom: 15px;
        }
        .p2 {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }
    }

    .Cardlist {
      margin-top: 30px;
      position: relative;
      padding: 0 30px;
      .Carditem {
        cursor: pointer;
        width: 370px;
        height: 270px;
        background: #ffffff;
        box-shadow: 0px -4px 20px 1px rgba(0, 0, 0, 0.03);
        position: relative;
        // margin-left: 150px;
        .cardbg2 {
          width: 330px;
          height: 120px;
          margin-top: 20px;
        }
        .Cardboxtext {
          width: 100%;
          height: 130px;
          padding: 15px 10px 15px 20px;
          .p1 {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 24px;
            margin-bottom: 10px;
          }
          .p2 {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
  }

  .Cardfooter {
    max-width: 1200px;
    margin: 30px auto;
    position: relative;
    .Cardleft {
      width: 50%;
      height: 730px;
      .Cardt {
        width: 100%;
      }

      .Cardbottom-l {
        width: 50%;
        height: 480px;
      }
      .Cardbottom-r {
        width: 50%;
        height: 480px;
      }
      .Carditem2 {
        width: 100%;
        height: 480px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
          // background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
    .Cardright {
      width: 50%;
      height: 730px;
      .Cardt {
        width: 100%;
      }

      .Cardbottom {
        width: 100%;
        height: 480px;
      }

      .Cardbottom-l {
        width: 100%;
        height: 230px;
      }
      .Cardbottom-r {
        width: 100%;
        height: 230px;
      }
      .Carditem3 {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem2 {
        width: 100%;
        height: 480px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
.SaaSfooter {
  margin-top: 50px;
  width: 100%;
  position: relative;
  .fimg {
    width: 100%;
    height: 200px;
  }
  .SaaSfl {
    position: relative;
    width: 50%;
    height: 150px;
    .SaaSflimg {
      width: 100%;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .pp {
      height: 24px;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      line-height: 24px;
      margin-top: 32px;
      position: relative;
    }

    .SaaSflbox {
      position: relative;
      height: 45px;
      width: 510px;
      margin-top: 20px;
      .sline {
        margin: 0 10px 0 6px;
        font-size: 20px;
        font-weight: 400;
        color: #ffd1a3;
        line-height: 45px;
        width: 2px;
        height: 28px;
        opacity: 1;
        // background-color: #ffffff;
      }
      .SaaSflitem {
        height: 45px;
        .p1 {
          margin-left: 5px;
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          line-height: 45px;
        }
        .p2 {
          margin-left: 5px;
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          line-height: 45px;
        }
      }
    }
  }
  .SaaSfr {
    position: relative;
    width: 50%;
    height: 150px;
    .SaaSfrimg {
      width: 100%;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
.paddingfix {
  padding-top: 0 !important;
}
</style>
<style>
.hover-search-fix {
  width: 100%;
  height: 74px;
}
.hover-search {
  width: 100%;
  height: 74px;
  transform: translateY(-200px);
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 9999;
  box-shadow: 0 0 10px 2px rgb(90 90 90 / 60%);
  /* transition: 0.35s; */
}
.show {
  transform: translateY(0);
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  top: 0;
}
.SaaSbanner .ivu-carousel-dots-inside {
  bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/jtjc/CloudSaaS2.vue